var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',[_c('a-col',{staticClass:"d-flex flex-column justify-content-center align-items-center",attrs:{"span":24}},[_c('div',{staticClass:"mt-5 mb-3 pbz-font subtitle-md-medium"},[_vm._v(" Data Not Found ")]),_c('div',{staticClass:"text-center pbz-font body-md-regular",staticStyle:{"color":"#999999"}},[_vm._v(" Call IT Admin. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }